import React from "react";
import { useSelector, useDispatch } from "react-redux";
import PerfectScrollbar from "react-perfect-scrollbar";
import makeStyles from "@material-ui/core/styles/makeStyles";
// import ArrowForward from "@material-ui/icons/ArrowForward";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
// import MonetizationOn from "@material-ui/icons/MonetizationOn";
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ShowChart from "@material-ui/icons/ShowChart";
import SearchIcon from "@material-ui/icons/Search";
// import Settings from "@material-ui/icons/Settings";
import Group from "@material-ui/icons/Group";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
// import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import HelpIcon from "@material-ui/icons/Help";
import MarkunreadMailboxIcon from "@material-ui/icons/MarkunreadMailbox";
import DashboardIcon from '@material-ui/icons/Dashboard';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import MessageIcon from '@material-ui/icons/Message';
import GroupIcon from '@material-ui/icons/Group';
import PeopleIcon from '@material-ui/icons/People';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Button } from "@material-ui/core";
// import {
//   AccountCircle,
//   ArrowForward,
//   Category,
//   Chat,
//   CheckCircle,
//   CloudUpload,
//   Colorize,
//   ContactMail,
//   Contacts,
//   Domain,
//   DonutSmall,
//   DragIndicator,
//   Edit,
//   EditAttributes,
//   Email,
//   Error,
//   Group,
//   ImportContacts,
//   InsertChart,
//   LibraryBooks,
//   LocalGroceryStore,
//   LockOutlined,
//   Map,
//   MonetizationOn,
//   NotificationImportant,
//   Notifications,
//   Person,
//   ShowChart,
//   Search,
//   Widgets,
// } from '@material-ui/icons';

import { ROLES } from "src/helpers/constants";
import CmtVertical from "../../../../../@coremat/CmtNavigation/Vertical";
import IntlMessages from "../../../../utils/IntlMessages";
import { logout } from "../../../../../store/slices/auth";

const useStyles = makeStyles(() => ({
	perfectScrollbarSidebar: {
		height: "100%",
		transition: "all 0.3s ease",
		".Cmt-sidebar-fixed &, .Cmt-Drawer-container &": {
			height: "calc(100% - 95px)",
		},
		".Cmt-modernLayout &": {
			height: "calc(100% - 72px)",
		},
		".Cmt-miniLayout &": {
			height: "calc(100% - 91px)",
		},
		".Cmt-miniLayout .Cmt-sidebar-content:hover &": {
			height: "calc(100% - 95px)",
		},
	},
	sidebarContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	mainNavigation: {
		flex: 1,
	},
	bottomNavigation: {
		borderTop: '1px solid rgba(0, 0, 0, 0.12)',
		paddingTop: '8px',
		marginTop: '8px',
	},
	logoutButton: {
		width: '100%',
		justifyContent: 'flex-start',
		padding: '12px 24px',
		color: 'inherit',
		textTransform: 'none',
		fontSize: '14px',
		fontWeight: 500,
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.08)',
		},
		'&:active': {
			backgroundColor: 'rgba(0, 0, 0, 0.12)',
		},
		'& .MuiButton-startIcon': {
			marginRight: '12px',
			marginLeft: 0,
		},
	},
	logoutIcon: {
		fontSize: '20px',
	},
}));

const SideBar = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { currentRole, authUser } = useSelector(({ auth }) => auth);
	let menus = [];
	if (authUser.roles.includes(ROLES.TENANT_ADMIN)) {
		menus.push(
			{
				name: "Founder Applications",
				icon: <MarkunreadMailboxIcon />,
				type: "item",
				link: "/applications/founders",
			},
			{
				name: "Funder Applications",
				icon: <MonetizationOn />,
				type: "item",
				link: "/applications/funders",
			},
			{
				name: "Vendor Applications",
				icon: <PeopleIcon />,
				type: "item",
				link: "/applications/vendor",
			},
			{
				name: <IntlMessages id={"sidebar.campaign"} />,
				icon: <SearchIcon />,
				type: "item",
				link: "/campaigns",
			},
			{
				name: "Funding Opportunities",
				icon: <MonetizationOn />,
				type: "item",
				link: "/opportunities",
			},
			{
				name: "Your Services / Products",
				icon: <BusinessCenterIcon />,
				type: "item",
				link: "/services",
			},
			{
				name: 'Matches',
				icon: <GroupIcon />,
				type: 'item',
				link: '/admin/matches',
			}
		);
	}
	if (currentRole === ROLES.FOUNDER) {
		if (
			!authUser.roles.includes(ROLES.SUPERADMIN) &&
			!authUser.roles.includes(ROLES.TENANT_ADMIN)
		) {
			menus.push(
				{
					name: <IntlMessages id={"sidebar.campaign"} />,
					icon: <SearchIcon />,
					type: "item",
					link: "/campaigns",
				},
				{
					name: "Teams",
					icon: <Group />,
					type: "item",
					link: "/teams",
				},
				{
					name: "Matches",
					icon: <GroupIcon />,
					type: "item",
					link: "/founder-matches",
				},
				{
					name: "Schedules",
					icon: <CalendarTodayIcon />,
					type: "item",
					link: "/schedules",
					disabled: true,
					style: { color: '#bdbdbd', cursor: 'not-allowed', pointerEvents: 'none', backgroundColor: '#f5f5f5' },
				},
				{
					name: "Messages",
					icon: <MessageIcon />,
					type: "item",
					link: "/messages",
					disabled: true,
					style: { color: '#bdbdbd', cursor: 'not-allowed', pointerEvents: 'none', backgroundColor: '#f5f5f5' },
				}
			);
		}
	} else if (currentRole === ROLES.FUNDER) {
		menus.push({
			name: "Funding Opportunities",
			icon: <MonetizationOn />,
			type: "item",
			link: "/opportunities",
		});
		if (authUser.profile.isAngel !== true) {
			menus.push({
				name: "My Organization",
				icon: <Group />,
				type: "item",
				link: "/organization",
			});
		}
	} else if (currentRole === ROLES.VENDOR) {
		menus.push(
			{
				name: "Your Services / Products",
				icon: <BusinessCenterIcon />,
				type: "item",
				link: "/services",
			},
			{
				name: "Match Found",
				icon: <GroupIcon />,
				type: "item",
				link: "/matches",
			},
			{
				name: "Schedules",
				icon: <CalendarTodayIcon />,
				type: "item",
				link: "/schedules",
				disabled: true,
				style: { color: '#bdbdbd', cursor: 'not-allowed', pointerEvents: 'none', backgroundColor: '#f5f5f5' },
			},
			{
				name: "Messages",
				icon: <MessageIcon />,
				type: "item",
				link: "/messages",
				disabled: true,
				style: { color: '#bdbdbd', cursor: 'not-allowed', pointerEvents: 'none', backgroundColor: '#f5f5f5' },
			}
		);
	}
	// if (authUser.roles.includes(ROLES.SUPERADMIN)) {
	// 	menus.push({
	// 		name: 'Matches',
	// 		icon: <GroupIcon />,
	// 		type: 'item',
	// 		link: '/admin/matches',
	// 	});
	// }

	const mainNavigationMenus = [
		{
			name: <IntlMessages id={"sidebar.dashboard"} />,
			icon: <DashboardIcon />,
			type: "item",
			link: "/dashboard",
		},
		{
			name: "Your Profile",
			icon: <PersonOutlineIcon />,
			type: "item",
			link: "/profile",
		},
		// {
		// 	name: "Our Organization",
		// 	icon: <AccountBalanceIcon />,
		// 	type: "item",
		// 	link: "/organization",
		// },

		...menus,
		// {
		// 	name: <IntlMessages id={"sidebar.opportunity"} />,
		// 	icon: <MonetizationOn />,
		// 	type: "item",
		// 	link: "/opportunities",
		// },
		// {
		//   name: <IntlMessages id={'sidebar.team'} />,
		//   icon: <Group />,
		//   type: 'item',
		//   link: '/team',
		// },
		// {
		//   name: <IntlMessages id={'sidebar.teammember'} />,
		//   icon: <Contacts />,
		//   type: 'item',
		//   link: '/teammember',
		// },
		// {
		//   name: <IntlMessages id={'sidebar.task'} />,
		//   icon: <CheckCircle />,
		//   type: 'item',
		//   link: '/task',
		// },
		// {
		//   name: <IntlMessages id={'sidebar.alert'} />,
		//   icon: <NotificationImportant />,
		//   type: 'item',
		//   link: '/alert',
		// },
		// {
		// 	name: "FAQs",
		// 	icon: <LibraryBooks />,
		// 	type: "item",
		// 	link: "/faq",
		// },
	];

	const bottomNavigationMenus = [
		{
			name: "Contact Us",
			icon: <HelpIcon />,
			type: "item",
			link: "/contact-us",
		},
	];

	// if (authUser && authUser.roles.includes("SUPERADMIN")) {
	// 	navigationMenus.push({
	// 		name: <IntlMessages id={"sidebar.admin"} />,
	// 		icon: <Settings />,
	// 		type: "collapse",
	// 		children: [
	// 			{
	// 				name: "Founders",
	// 				icon: <ArrowForward />,
	// 				type: "collapse",
	// 				children: [
	// 					{
	// 						name: "Founders Form",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/campaign",
	// 					},
	// 					{
	// 						name: "Founder Profile",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/founder_profile",
	// 					},
	// 					{
	// 						name: "Founder Member",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/founder_member",
	// 					},
	// 					{
	// 						name: "Team Member",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/team_member",
	// 					},
	// 					{
	// 						name: "All Campaigns",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/campaigns",
	// 					},
	// 				],
	// 			},
	// 			{
	// 				name: "Funders",
	// 				icon: <ArrowForward />,
	// 				type: "collapse",
	// 				children: [
	// 					{
	// 						name: "Funders Form",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/opportunity",
	// 					},
	// 					{
	// 						name: "Funder Profile",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/funder_profile",
	// 					},
	// 					{
	// 						name: "Funders Org",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/funder_organization",
	// 					},
	// 					{
	// 						name: "All Opportunities",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/opportunities",
	// 					},
	// 				],
	// 			},
	// 			{
	// 				name: "Vendors",
	// 				icon: <ArrowForward />,
	// 				type: "collapse",
	// 				children: [
	// 					{
	// 						name: "Vendors Form",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/vendor",
	// 					},
	// 					{
	// 						name: "Vendors Profile",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/questions/vendor_profile",
	// 					},
	// 					{
	// 						name: "Vendor Tokens",
	// 						icon: <ArrowForward />,
	// 						type: "item",
	// 						link: "/admin/vendor-tokens",
	// 					},
	// 				],
	// 			},
	// 			// {
	// 			// 	name: "All Opportunities",
	// 			// 	icon: <ArrowForward />,
	// 			// 	type: "item",
	// 			// 	link: "/admin/opportunities",
	// 			// },
	// 			{
	// 				name: "Match",
	// 				icon: <ArrowForward />,
	// 				type: "item",
	// 				link: "/admin/match",
	// 			},

	// 			// {
	// 			// 	name: "Manage FAQs",
	// 			// 	icon: <ArrowForward />,
	// 			// 	type: "item",
	// 			// 	link: "/admin/faqs",
	// 			// },
	// 			{
	// 				name: "Manage Users",
	// 				icon: <ArrowForward />,
	// 				type: "item",
	// 				link: "/admin/users",
	// 			},
	// 			// {
	// 			// 	name: "Match Preview",
	// 			// 	icon: <ArrowForward />,
	// 			// 	type: "item",
	// 			// 	link: "/admin/match-preview",
	// 			// },
	// 		],
	// 	});
	// }

	return (
		<PerfectScrollbar className={classes.perfectScrollbarSidebar}>
			<div className={classes.sidebarContainer}>
				<div className={classes.mainNavigation}>
					<CmtVertical menuItems={mainNavigationMenus} />
				</div>
				<div className={classes.bottomNavigation}>
					<CmtVertical menuItems={bottomNavigationMenus} />
					<Button
						className={classes.logoutButton}
						onClick={() => dispatch(logout())}
						startIcon={<ExitToAppIcon className={classes.logoutIcon} />}
						disableRipple={false}
						disableFocusRipple={false}
					>
						Logout
					</Button>
				</div>
			</div>
		</PerfectScrollbar>
	);
};

export default SideBar;
